import { render, staticRenderFns } from "./ApproachForm.vue?vue&type=template&id=6bc02f36"
import script from "./ApproachForm.vue?vue&type=script&lang=js"
export * from "./ApproachForm.vue?vue&type=script&lang=js"
import style0 from "./ApproachForm.vue?vue&type=style&index=0&id=6bc02f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports